module.exports = __webpack_public_path__ + "static/southeast-logo-4258733e8ea995a46389f44ed7008ad4.jpg";